<div class="auth-container">
  <mat-card class="auth-card">
    <mat-card-header>
      <mat-card-title>Neues Passwort festlegen</mat-card-title>
      @if (!message) {
        <mat-card-subtitle>Bitte gib dein neues Passwort ein.</mat-card-subtitle>
      }
    </mat-card-header>

    <mat-card-content>
      @if (!message) {
        <form (ngSubmit)="resetPassword()">
          <mat-form-field appearance="outline">
            <mat-label>Neues Passwort</mat-label>
            <mat-icon matPrefix>lock</mat-icon>
            <input matInput [formControl]="passwordControl" [type]="hidePassword ? 'password' : 'text'" required />
            <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button">
              <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </mat-form-field>
          <button mat-flat-button color="accent" type="submit" [disabled]="passwordControl.invalid">
            Passwort speichern
          </button>
        </form>
      } @else {
        <div class="message-display error">
          <mat-icon>error</mat-icon>
          <p>{{ message }}</p>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
